import "./CallButton.module.scss";
import {FragmentProps} from "@applant/fragment-scripts/fragment/Fragment";

type RootComponentProps = {
    baseUrl: string;
    contactNumber: string;
};

const initializeCallButton = (root: HTMLElement) => {
    const { contactNumber } = getRootComponentProps(root) || { contactNumber: '' };
    window.handlerRegistry = window.handlerRegistry || {};

    window.handlerRegistry.onCall = function (event: MouseEvent): void {
        event.preventDefault();
        window.open(`tel:${contactNumber}`, "_self");
    }
};

const getRootComponentProps = (root: HTMLElement): RootComponentProps => {
    const fragmentName = root.dataset.id;
    if (!fragmentName) {
        throw new Error("Cannot initialize call button. Failed to get fragment root props.");
    }

    return (window?.Applant?.data?.[root.dataset.id as string] as FragmentProps<RootComponentProps>).rootComponentProps;
}

export { initializeCallButton };